function convertToDatetime(timeStr, dateStr) {
  const match = timeStr.match(/^(\d{1,2}):(\d{2})(AM|PM)$/i);
  if (!match) return null;

  let [_, hourStr, minuteStr, meridian] = match;
  let hour = parseInt(hourStr, 10);
  let minute = parseInt(minuteStr, 10);

  // Convert to 24-hour time
  if (meridian.toUpperCase() === "PM" && hour !== 12) hour += 12;
  if (meridian.toUpperCase() === "AM" && hour === 12) hour = 0;

  // Format start time
  const startHourStr = String(hour).padStart(2, "0");
  const startMinuteStr = String(minute).padStart(2, "0");
  const startTime = `${dateStr} ${startHourStr}:${startMinuteStr}`;

  // Calculate end time
  let endHour = hour;
  let endMinute = minute;

  if (minute === 0) {
    endHour += 1;
  } else if (minute === 30) {
    endMinute = 0;
    endHour += 1;
  }

  // Handle 24-hour rollover (optional, but safe)
  if (endHour >= 24) {
    endHour = 0;
  }

  const endHourStr = String(endHour).padStart(2, "0");
  const endMinuteStr = String(endMinute).padStart(2, "0");
  const endTime = `${dateStr} ${endHourStr}:${endMinuteStr}`;


  return { startTime, endTime };
}

export default convertToDatetime;